import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AlertModule } from "src/app/shared/components/alert/alert.module";
import { DropdownModule } from "src/app/shared/components/dropdown/dropdown.module";
import { ButtonModule } from "src/app/shared/components/button/button.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PmsSelectTypeComponent } from "./pms-select-type/pms-select-type.component";
import { PioneerRxConsentFormComponent } from "./pioneer-rx-consent-form/pioneer-rx-consent-form.component";
import { PmsPendingConnectionComponent } from "./pms-pending-connection/pms-pending-connection.component";
import { InputModule } from "src/app/shared/components/input/input.module";
import { PioneerRxConsentFormPdfService } from "./pioneer-rx-consent-form/pioneer-rx-consent-form-pdf.service";
import { PdfViewerModule } from "src/app/shared/components/pdf-viewer/pdf-viewer.module";
import { SignaturePadModule } from "src/app/shared/components/signature-pad/signature-pad.module";
import { PharmacyManagementSystemIntegrationDialogComponent } from "./pms-integration-dialog.component";
import { FrameworkLtcSetupComponent } from "./framework-ltc-setup/framework-ltc.component";

@NgModule({
    declarations: [
      PharmacyManagementSystemIntegrationDialogComponent,
      PmsSelectTypeComponent,
      PioneerRxConsentFormComponent,
      PmsPendingConnectionComponent,
      FrameworkLtcSetupComponent
    ],
    exports: [
      PharmacyManagementSystemIntegrationDialogComponent,
    ],
    imports: [
      CommonModule,
      AlertModule,
      DropdownModule,
      ButtonModule,
      FormsModule,
      ReactiveFormsModule,
      InputModule,
      PdfViewerModule,
      SignaturePadModule
    ],
    providers: [PioneerRxConsentFormPdfService]
  })
  export class PmsIntegrationDialogModule {
  }